import { IPostAvailableCourse } from "../../models/admin/availableCourse.model";
import {
  ILessonRes,
  ITopicRes,
} from "../../models/admin/course-creation.model";
import {
  ICourseSessionRes,
  ICourseTermRes,
} from "../../models/admin/courseTermSession.model";
import {
  DashboardRes,
  IUserProfileRes,
  IUserRes,
} from "../../models/admin/user.model";
import { ICourseTypeResponse, IDurationRes, IProgramTypeResponse } from "../../models/course.model";
import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";
const GETRAINEES = "admin/trainees";
const GETRAINERS = "admin/trainers";
const AVAILABLECOURSES = "available-courses";
const COURSESESSION = "course-sessions";
const COURSETERMS = "course-terms";
const COURSETYPE = "course-types";
const PGTYPE = "program-types";
const PROGRAMTYPES = "program-categories";
const EACHUSER = "users/";
const ASSIGNTRAINERTOCOURSE = "course-availability/";
const ADVERTISECOURSE = "courses/advertise";
const CREATECOURSE = "courses";
const CREATECOURSETOPIC = "courses/";
const DASHBOARD = "admin/dashboard";
const CENTERS = "centres";
const audittrail = "activitylogs";
const GETPOSTING = "admin/program-module-postings";
const ADJUSTPOSTING = "admin/approve-adjust-program-module-postings";

export default class AdminHelpers {
  static async getTrainers() {
    const response = await getService.get(CONFIG_API_URL + GETRAINERS);
    const data: IUserProfileRes = response.data;
    return data;
  }

  static async getPostings() {
    const response = await getService.get(CONFIG_API_URL + GETPOSTING);
    const data: any = response.data;
    return data;
  }

  static async approvePosting(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${ADJUSTPOSTING}`,
      data
    );
    return response.data;
  }

  static async getActivitylogs() {
    const response = await getService.get(CONFIG_API_URL + audittrail);
    const data: any = response.data;
    return data;
  }

  static async getAllCenters() {
    const response = await getService.get(CONFIG_API_URL + CENTERS);
    const data: any = response.data;
    return data;
  }

  static async getAdminDashboard() {
    const response = await getService.get(CONFIG_API_URL + DASHBOARD);
    const data: DashboardRes = response.data;
    return data;
  }

  static async createCourse(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATECOURSE}`,
      data
    );
    return response.data;
  }

  static async bulkCreateCourse(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/batch-courses`,
      data
    );
    return response.data;
  }

  // static async updateCourse(data: any, uuid: string) {
  //   try {
  //     const response = await putService.put(
  //       `${CONFIG_API_URL}courses/${uuid}`,
  //       data
  //     );

  //     return response?.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  static async updateCourse(data: any, uuid: string) {
    try {
      const response = await postService.post(
        `${CONFIG_API_URL}courses/${uuid}/update`,
        data
      );

      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async deleteCourse(uuid: string) {
    try {
      const response = await deleteService.delete(
        `${CONFIG_API_URL}courses/${uuid}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  static async createCourseTopic(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATECOURSETOPIC}${uuid}/topics`,
      data
    );
    const res: ITopicRes = response.data;
    return res;
  }

  static async createCourseLessons(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATECOURSETOPIC}${uuid}/new/lessons`,
      data
    );
    const res: ILessonRes = response.data;
    return res;
  }

  static async getCourseTypes() {
    const response = await getService.get(CONFIG_API_URL + COURSETYPE);
    const data: ICourseTypeResponse = response.data;
    return data;
  }

  static async getProgramTypes() {
    const response = await getService.get(CONFIG_API_URL + PGTYPE);
    const data: IProgramTypeResponse = response.data;
    return data;
  }

  static async getCourseDuration() {
    const response = await getService.get(
      CONFIG_API_URL + "program-data/course-durations"
    );
    const data: IDurationRes = response.data;
    return data;
  }
  //  program-data/course-durations
  static async getProgramCategories() {
    const response = await getService.get(CONFIG_API_URL + PROGRAMTYPES);
    const data: any = response.data;
    return data;
  }

  static async getEachUser(uuid: string | undefined) {
    const response = await getService.get(CONFIG_API_URL + EACHUSER + uuid);
    const data: IUserRes = response.data;
    return data;
  }

  static async getTrainees() {
    const response = await getService.get(CONFIG_API_URL + GETRAINEES);
    const data: IUserProfileRes = response.data;
    return data;
  }

  static async getSessions() {
    const response = await getService.get(CONFIG_API_URL + COURSESESSION);
    const data: ICourseSessionRes = response.data;
    return data;
  }

  static async getTerms() {
    const response = await getService.get(CONFIG_API_URL + COURSETERMS);
    const data: ICourseTermRes = response.data;
    return data;
  }

  static async availableCourse(data: IPostAvailableCourse) {
    const response = await postService.post(
      `${CONFIG_API_URL}${AVAILABLECOURSES}`,
      data
    );
    return response.data;
  }

  static async updateAvailableCourse(data: IPostAvailableCourse, uuid: string) {
    const response = await putService.put(
      `${CONFIG_API_URL}${AVAILABLECOURSES}/${uuid}`,
      data
    );
    return response.data;
  }

  static async assignTrainertoCourse(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${ASSIGNTRAINERTOCOURSE}${uuid}/trainers`,
      data
    );
    return response.data;
  }

  static async advertiseCourse(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${ADVERTISECOURSE}`,
      data
    );
    return response.data;
  }

  static async createRole(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}roles`, data);
    return response.data;
  }

  static async getRoles() {
    const response = await getService.get(`${CONFIG_API_URL}roles`);
    return response.data;
  }

  static async getDepartments() {
    const response = await getService.get(`${CONFIG_API_URL}admin/departments`);
    return response.data;
  }

  static async createAlumni(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/alumni`,
      data
    );
    return response.data;
  }

  static async getAlumni() {
    const response = await getService.get(`${CONFIG_API_URL}admin/alumni`);
    return response.data;
  }

  static async shortlistApplication(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/shortlist-applicants`,
      data
    );
    return response.data;
  }

  static async getShortlistedApplicants() {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/shortlisted-applicants`
    );
    return response.data;
  }

  static async updateCourseAvailability(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/update-course-availability`,
      data
    );
    return response.data;
  }

  static async getProgramCluster(course_id: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/trainees-by-program-clusters/${course_id}`
    );
    return response.data;
  }

  static async getUploadedResults(filter: any) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/uploaded-results${filter}`
    );
    return response.data;
  }

  // sending empty data
  static async declineResult(id: number) {
    const response = await putService.put(
      `${CONFIG_API_URL}admin/decline-uploaded-result/${id}`,
      {}
    );
    return response.data;
  }

  static async approveResult(id: number) {
    const response = await putService.put(
      `${CONFIG_API_URL}admin/approve-uploaded-result/${id}`,
      {}
    );
    return response.data;
  }

  static async createCourseTechnicality(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}course-types`,
      data
    );
    return response.data;
  }
  static async updateCourseTechnicality(data: any, uuid: string | undefined) {
    const response = await putService.put(
      `${CONFIG_API_URL}course-types/${uuid}`,
      data
    );
    return response.data;
  }
  static async deleteCourseTechnicality(uuid: string) {
    try {
      const response = await deleteService.delete(
        `${CONFIG_API_URL}course-types/${uuid}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  static async adminCreateAnnouncement(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/general-announcements`,
      data
    );
    return response.data;
  }

  static async adminUpdateAnnouncement(data: any, uuid: string) {
    try {
      const response = await putService.put(
        `${CONFIG_API_URL}admin/general-announcements/${uuid}`,
        data
      );

      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  static async deleteTheAnnouncement(uuid: string) {
    try {
      const response = await deleteService.delete(
        `${CONFIG_API_URL}admin/general-announcements/${uuid}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  static async uploadTrainingCalendar(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/training-calendar`,
      data
    );
    return response.data;
  }
  static async downloadAdminResult(
    courseId: number,
    sessionId: number,
    termId: number
  ) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/export-results/${courseId}/${sessionId}/${termId}`,
      {
        responseType: "blob", // Specify responseType as 'blob'
      }
    );
    return response.data; // Return the blob data
  }
}
